export const jointClaimsQueueConstants = {
    GET_CLAIMS_QUEUE: "GET_CLAIMS_QUEUE",
    GET_CLAIMS_QUEUE_SUCCESS: "GET_CLAIMS_QUEUE_SUCCESS",
    CLEAR_QUEUE: "CLEAR_QUEUE"
}